import menu from "assets/theme/components/menu";
import { isEmptyObject } from "utilities/common";

export function homePageValidation(fields) {
  const errors = {};
  const validURL = (url) => {
    const urlPattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,})" + // domain name
      "(\\:\\d+)?" + // port
      "(\\/[-a-z\\d%@_.~+&:]*)*" + // path
      "(\\?[;&a-z\\d%@_.,~+&:=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$", // fragment
      "i"
    );
    return !!urlPattern.test(url);
  };
  // ==============================
  // BASIC DETAILS
  // ==============================

  if (!fields.metaTitle || fields.metaTitle.trim() === "") {
    errors.metaTitle = "Meta title is required";
  }

  if (!fields.metaDescription || fields.metaDescription.trim() === "") {
    errors.metaDescription = "Meta description is required";
  }
  const isQuillEmpty = (val = "") => {
    const v = val.trim();
    return v === "" || v === "<p><br></p>" || v === "<br>" || v === "<p></p>";
  };

  // // ==============================
  // // HERO SECTION
  // // ==============================
  if (!fields.heroSection?.title || fields.heroSection.title.trim() === "") {
    errors.heroTitle = "Heading is required";
  }
  if (isQuillEmpty(fields.heroSection.heroSectionPara)) {
    errors.heroSectionPara = "Paragraph is required";
  }

  if (!fields.heroSection?.banners || !Array.isArray(fields.heroSection.banners)) {
    errors.heroBanners = "At least three banners in Hero section are required";
  } else {
    const banners = fields.heroSection.banners;

    // Check minimum 3 banners
    if (banners.length < 3) {
      errors.heroBanners = "At least three banners in Hero section are required";
    }

    // Check if at least one banner is active
    const hasActiveBanner = banners.some((b) => b.status === "active");
    if (!hasActiveBanner) {
      errors.heroBannersActive = "At least one banner in Hero section must be active";
    }
  }



  // // ==============================
  // // CATEGORY SECTION
  // // ==============================
  if (
    !fields.categorySection ||
    !Array.isArray(fields.categorySection) ||
    fields.categorySection.length === 0
  ) {
    errors.categorySection = "At least one category section is required";
  } else {
    fields.categorySection.forEach((section, index) => {
      if (!section.categoryName?.trim()) {
        errors[`categorySection[${index}].categoryName`] = "Category name is required";
      }
      if (!section.bentoGridHeading?.trim()) {
        errors[`categorySection[${index}].bentoGridHeading`] =
          "Bento Grid Heading (H2) is required";
      }
      // if (!section.bentoGridHeading1?.trim()) {
      //   errors[`categorySection[${index}].bentoGridHeading1`] =
      //     "Bento Grid Heading (H2) is required";
      // }
      if (!section.layoutType?.trim()) {
        errors[`categorySection[${index}].layoutType`] = "Layout type is required";
      }
      // If defaultRedirectUrlEnable is true, defaultGridUrl must be non-empty
      if (section.defaultRedirectUrlEnable && !section.defaultGridUrl?.trim()) {
        errors[`categorySection[${index}].defaultGridUrl`] =
          "Default grid URL is required if redirect is enabled";
      }

      // Only validate if categorySection and layoutType is not 'No Grid'
      if (fields.categorySection && section?.layoutType !== "No Grid") {
        // Desktop Banner validation
        if (!section.desktopBanner?.imageUrl?.trim()) {
          errors[`categorySection[${index}].desktopBanner.imageUrl`] =
            "Desktop banner image is required";
        }
        // Mobile Banner validation
        if (!section.mobileBanner?.imageUrl?.trim()) {
          errors[`categorySection[${index}].mobileBanner.imageUrl`] =
            "Mobile banner image is required";
        }

        // Desktop Grid validation
        if (!Array.isArray(section.desktopGrid) || section.desktopGrid.length === 0) {
          errors[`categorySection[${index}].desktopGrid`] =
            "At least one desktop grid item is required";
        }
        // Mobile Grid validation
        if (!Array.isArray(section.mobileGrid) || section.mobileGrid.length === 0) {
          errors[`categorySection[${index}].mobileGrid`] =
            "At least one mobile grid item is required";
        }
      }
    });
  }

  // // ==============================
  // // CUSTOMER REVIEWS
  // // ==============================
  if (!fields.customerReviews || fields.customerReviews.trim() === "") {
    errors.customerReviews = "Title is required";
  }

  // // ==============================
  // // DELIVERY SECTION
  // // ==============================
  if (!fields.deliverySection?.sectionTitle?.trim()) {
    errors.deliverySectionTitle = "Title is required";
  }

  if (!fields.deliverySection?.sectionPara?.trim()) {
    errors.deliverySectionPara = "Paragraph is required";
  }

  if (
    !Array.isArray(fields.deliverySection?.subData) ||
    fields.deliverySection.subData.length === 0
  ) {
    errors.deliverySectionSubData = "At least one item in delivery section required";
  } else {
    fields.deliverySection.subData.forEach((item, index) => {
      // Image Validation
      if (!item.image?.trim()) {
        errors[`deliverySubData_${item.deliveryId || index}_image`] = "Icon is required";
      }

      // Heading Validation
      if (!item.heading?.trim()) {
        errors[`deliverySubData_${item.deliveryId || index}_heading`] =
          "Heading is required";
      }

      // SubHeading Validation
      if (!item.subHeading?.trim()) {
        errors[`deliverySubData_${item.deliveryId || index}_subHeading`] =
          "Sub-Heading is required";
      }

      // Paragraph Validation
      if (!item.paragraph?.trim()) {
        errors[`deliverySubData_${item.deliveryId || index}_paragraph`] =
          "Paragraph is required";
      }
    });
  }


  /////// 
  ///////

  if (isQuillEmpty(fields.stateParagraph)) {
    errors.stateParagraph = "Content is required";
  }

  // // ==============================
  // // FAQ SECTION
  // // ==============================
  if (!fields.faqSection?.title?.trim()) {
    errors.faqTitle = "Title is required";
  }

  if (!Array.isArray(fields.faqSection?.subData) || fields.faqSection.subData.length === 0) {
    errors.faqSectionSubData = "At least one item in FAQ section is required";
  } else {
    fields.faqSection.subData.forEach((item) => {
      if (isQuillEmpty(item.question)) {
        errors[`faq_${item.faqId}_question`] = "Question is required";
      }
      if (isQuillEmpty(item.answer)) {
        errors[`faq_${item.faqId}_answer`] = "Answer is required";
      }
    });
  }

  // // ==============================
  // // FOOTER SECTION
  // // ==============================
  const menus = fields.footerSection?.menusItems || {};

  // ---- Overview CTA1 ----

  const overview = menus.overView?.subData;
  if (!overview?.cta1?.label?.trim()) {
    errors.overView_cta1_label = "CTA in OverView section is required";
  }
  if (!overview?.cta1?.url?.trim()) {
    errors.overView_cta1_url = "URL is required";
  } else if (!validURL(overview?.cta1?.url?.trim())) {
    errors.overView_cta1_url = "Enter valid Url";
  }
  if (!overview?.cta2?.label?.trim()) {
    errors.overView_cta2_label = "CTA is required";
  }
  if (!overview?.cta2?.url?.trim()) {
    errors.overView_cta2_url = "URL is required";
  } else if (!validURL(overview?.cta2.url?.trim())) {
    errors.overView_cta2_url = "Enter valid Url";
  }

  if (isQuillEmpty(overview?.description)) {
    errors.overView_desc = "C.A. License is required";
  }

  // if (!Array.isArray(fields.footerSection?.locationList)) {
  //   errors.locationList = "Location list must be an array";
  // }

  // // Menus validation
  // if (
  //   !Array.isArray(fields.footerSection?.locationList) ||
  //   fields.footerSection.locationList.length === 0
  // ) {
  //   errors.locationList = "At least one location is required";
  // }

  return { errors, isValid: isEmptyObject(errors) };
}
